import {createContext} from 'react'

export const MandatoryContext = createContext()
